<template>
<portal :to="name" :disabled="!active">
    <div class="modal-dialog" :class="size" v-if="active" :key="uuid">
        <div class="modal-content">
            <div v-if="forceHeader || $slots.header" class="modal-header tw-flex tw-items-center tw-justify-between">
                <h5 class="modal-title">
                    <slot name="header"></slot>
                </h5>

                <div>
                    <button type="button" class="close tw-m-0 tw-leading-3" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        
            <div class="modal-body">
                <slot name="body"></slot>
            </div>

            <div class="modal-footer" v-if="!disableFooter">
                <slot name="footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </slot>
            </div>
        </div>
    </div>
</portal>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default {
    name: "ModalContent",

    props: {
        name: {
            type: String,
            required: true
        },
        size: {
            type: String,
            default: ""
        },
        closeOn: {
            type: String,
            default: null
        },
        disableFooter: {
            type: Boolean,
            default: false
        },
        forceHeader: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            active: false,
            uuid: uuidv4(),
        }
    },

    watch: {
        active: {
            handler(newValue) {
                this.$nextTick(() => {
                    EventBus.$emit('modal-loaded');
                })
            }
        }
    },

    mounted() {
        // When a modal-button is clicked corresponding to this modal, activate the portal and show the content
        EventBus.$on('modal-custom', event => {
            if(event.name == this.name) {
                this.active = true;
            }
        });

        EventBus.$on('close-modal', event => {
            this.close();
        });

        // When the modal is closed, disable the portal and hide the content
        EventBus.$on('modal-closed', event => {
            this.active = false;
        });

        if(this.closeOn) {
            EventBus.$on(this.closeOn, () => {
                console.log('received close event');
                this.close();
            })
        }
    },

    methods: {
        open() {
            EventBus.$emit('modal-custom', { name: this.name });
        },

        close() {
            $('#modal').modal('hide');
        }
    }
}
</script>

<style>

</style>